import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

/*
import {createRoot} from 'react-dom/client';

const root = createRoot(document.getElementById('root'));
root.render(<App/>);
*/

/* Beide methoden leveren hetzelfde resultaat: */
/*
const heading = <h1 className="site-heading">Hello, React</h1>;

const tekst = 'Hello, React';
const heading = <h1 className="site-heading">{tekst}</h1>;

const heading = React.createElement(
  'h1',
  {className: 'site-heading'},
  'Hello, React'
);
*/
